import { StateCreator } from 'zustand';
import type { UserClientDocument } from 'common/user/UserDocument';
import { createPersistentState } from 'client/lib/State';

export interface UserState {
  user: UserClientDocument | null;
  loggedIn: boolean;
  login: (user: UserClientDocument) => void;
  logout: VoidFunction;
  updateSshKeyCount: (sshKeyCount: number) => void;
  /** Is set to true before initial "/user/auth" call */
  isPendingUpdate: boolean;
  /** Is used to remember which account was selected when navigating to root pages */
  account: string | null;
}

const initialState: StateCreator<UserState> = (set) => ({
  user: null,
  projects: [],
  loggedIn: false,
  isPendingUpdate: true,
  account: null,
  login: (user) => set(() => ({ loggedIn: true, isPendingUpdate: false, user })),
  logout: () => set(() => ({ loggedIn: false, isPendingUpdate: false })),
  updateSshKeyCount: (sshKeyCount: number) => {
    const user = useUserState.getState().user;
    if (!user) return;
    set({ user: { ...user, sshKeyCount } });
  },
});

export const useUserState = createPersistentState('user-session', initialState, (state) =>
  // Do not store "isPendingUpdate" in localStorage
  Object.fromEntries(Object.entries(state).filter(([key]) => !['isPendingUpdate', 'account'].includes(key)))
);
